import React from 'react';
import { ButtonColor, ButtonVariant, Modal } from 'react-magma-dom';
import { CloseModalIcon } from '../../assets/icons/ImageEditTool';
import { Video } from '../Media/Video';
import { MarginWrapper, StyledVideoModalCloseButton } from '../Styled';

interface IVideoModal {
  showModal: boolean;
  id: string;
  setShowModal: (isOpen: boolean) => void;
}

export const VideoModal = (props: IVideoModal): JSX.Element => {
  const { id, showModal, setShowModal } = props;

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal isOpen={showModal} isCloseButtonHidden onClose={handleClose} testId="video-modal">
      <div>
        <StyledVideoModalCloseButton
          testId="reset-modal-close"
          aria-label="Close default images modal window"
          color={ButtonColor.secondary}
          variant={ButtonVariant.link}
          icon={<CloseModalIcon />}
          onClick={handleClose}
        />
      </div>
      <MarginWrapper margin="0px 36px 5px">
        <Video id={id} />
      </MarginWrapper>
    </Modal>
  );
};
